








































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

import getImage from '@/utils/helpers'

declare const config: any

@Component
export default class EmailComponent extends Vue {
    @Prop({ default: '' })
    data!: object

    @Prop({ default: '' })
    goodAnswer!: object

    @Prop({ default: '' })
    seeGoodAnswer!: object

    @Prop({ default: '' })
    mode!: object

    @Watch('data')
    onPropertyChanged() {
        this.email = this.data
        this.emailBody = getImage('emails', this.email, this.mobileMode)
    }

    email: any
    emailBody = ''
    servUrl!: string
    screenSize!: number
    innerWidth!: number
    mobileMode = false

    created() {
        window.addEventListener('resize', this.onResize)
        this.servUrl = config.BASE_URL
        this.email = this.data
        this.onResize()
        this.emailBody = getImage('emails', this.email, this.mobileMode)
    }

    onResize(event?: any) {
        this.innerWidth = window.innerWidth
        if (this.innerWidth <= 980) {
            this.mobileMode = true
        } else {
            this.mobileMode = false
        }
    }
}
